import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'
import referralimage from './refer-a-friend.png'

export const meta: MetaFunction = () => [{ title: 'Referral Program' }]

const Referrals = () => (
	<main className="mx-auto my-10 max-w-7xl">
		<Link to="/" prefetch="intent" className="text-blue-600 underline">
			Home
		</Link>
		<br />
		<br />
		<h1 className="py-3 text-4xl font-black">Referral Rewards Program</h1>

		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			We strive to treat each customer with professionalism and to go the extra
			mile when it comes to providing customer service. If we have done our part
			successfully and consistently, we will earn your trust and confidence and
			you will want your friends and family to receive the same treatment.
		</p>

		<img src={referralimage} alt="Refer A Friend" width="256" height="256" />

		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			When we are contacted to talk about insurance with someone new, we ask how
			they found us. We have found that most people who call us do so at the
			recommendation of a family member or friend. When you are the person who
			recommended us, we'll show our appreciation for the referral by sending
			you a gift card. The person does not need to become a customer in order
			for you to receive this token of gratitude.
		</p>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			Certain insurance products, such as Medicare Insurance Plans, have federal
			laws prohibiting that we pay you a referral bonus for telling your friends
			that we can help with medicare insurance plans. We are grateful when you
			refer medicare-eligible people to us so that we can help them with review
			their medicare plan options, however we cannot pay you a referral bonus
			for that type of referral.
		</p>
	</main>
)

export default Referrals
